import * as React from 'react';

import { Colors, Grid } from '@coursera/cds-core';

import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import MobileMenuIconGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuIconGridItem';
import SimpleMobileMenuConfig from 'bundles/composable-page-header/module-renderers/SimpleMobileMenuConfig';

type Props = {
  customHeaderLogos?: Array<React.ReactNode>;
  acctDropdownLogoutOnly?: boolean;
  enableCourseraLogoLink?: boolean;
  showProgramSwitcher?: boolean;
  showLanguageDropdown?: boolean;
  showAcctDropdown?: boolean;
  showAcctItemsInMain?: boolean;
  showSignupBtn?: boolean;
  showLoginBtn?: boolean;
  showMobileHamburger?: boolean;
};

const LoggedInConsumerSimpleMobileMainNav = ({
  customHeaderLogos = undefined,
  enableCourseraLogoLink = true,
  showProgramSwitcher = false,
  showLanguageDropdown = true,
  acctDropdownLogoutOnly = false,
  showAcctDropdown = true,
  showAcctItemsInMain = false,
  showSignupBtn = true,
  showLoginBtn = true,
  showMobileHamburger = true,
}: Props) => {
  const courseraLogo = (
    <HomeLogoGridItemModule
      href={enableCourseraLogoLink ? '/' : undefined}
      logos={
        customHeaderLogos?.length
          ? customHeaderLogos
          : [<CourseraHomeLogo key="1" logoColor={!enableCourseraLogoLink ? Colors.gray[900] : undefined} />]
      }
    />
  );

  return (
    <MainNavigationWrapper>
      <Grid item xs={8} sm={6} container alignItems="center">
        {showMobileHamburger && (
          <MobileMenuIconGridItem
            menuConfig={
              <SimpleMobileMenuConfig
                acctDropdownLogoutOnly={acctDropdownLogoutOnly}
                showProgramSwitcher={showProgramSwitcher}
                showLanguageDropdown={showLanguageDropdown}
                showAcctDropdown={showAcctDropdown}
                showAcctItemsInMain={showAcctItemsInMain}
                showSignupBtn={showSignupBtn}
                showLoginBtn={showLoginBtn}
              />
            }
            homeLogo={courseraLogo}
          />
        )}
        {courseraLogo}
      </Grid>
    </MainNavigationWrapper>
  );
};

export default LoggedInConsumerSimpleMobileMainNav;
